// Define the LocalStorageService class
var LocalStorageService = /** @class */ (function () {
    function LocalStorageService() {
    }
    LocalStorageService.getSanitizeKey = function (key) {
        return "".concat(this.PREFIX, " ").concat(key);
    };
    // Method to set an item in local storage
    LocalStorageService.setItem = function (key, value) {
        try {
            var serializedValue = JSON.stringify(value);
            localStorage.setItem(this.getSanitizeKey(key), serializedValue);
        }
        catch (error) {
            console.error("Error setting item with key \"".concat(key, "\":"), error);
        }
    };
    // Method to get an item from local storage
    LocalStorageService.getItem = function (key) {
        try {
            var serializedValue = localStorage.getItem(this.getSanitizeKey(key));
            if (serializedValue === null) {
                return null;
            }
            return JSON.parse(serializedValue);
        }
        catch (error) {
            console.error("Error getting item with key \"".concat(key, "\":"), error);
            return null;
        }
    };
    // Method to remove an item from local storage
    LocalStorageService.removeItem = function (key) {
        try {
            localStorage.removeItem(this.getSanitizeKey(key));
        }
        catch (error) {
            console.error("Error removing item with key \"".concat(key, "\":"), error);
        }
    };
    // Method to clear all items from local storage
    LocalStorageService.clear = function () {
        var _this = this;
        try {
            // Use a loop to remove all keys with the specific prefix
            Object.keys(localStorage).forEach(function (key) {
                if (key.startsWith(_this.PREFIX)) {
                    localStorage.removeItem(key);
                }
            });
        }
        catch (error) {
            console.error('Error clearing local storage:', error);
        }
    };
    LocalStorageService.PREFIX = 'shupp_';
    return LocalStorageService;
}());
export default LocalStorageService;
